export const mua = "https://mua.kpru.ac.th/FrontEnd_Admission";
// export const mua = "https://git.kpru.ac.th/FrontEnd_Admission";
